import { render, staticRenderFns } from "./CommunityInfoTable.vue?vue&type=template&id=462980d4&scoped=true&"
import script from "./CommunityInfoTable.vue?vue&type=script&lang=js&"
export * from "./CommunityInfoTable.vue?vue&type=script&lang=js&"
import style0 from "./CommunityInfoTable.vue?vue&type=style&index=0&id=462980d4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "462980d4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VBtn,VDataTable,VIcon,VRow,VSnackbar,VTextField,VToolbar})
